import { StaticPropsContext } from '@otovo/shared/lib/next/types';
import { Sanity$BlogPage } from '@otovo/shared/types/sanityTypes';
import { useQuery } from '@sanity/react-loader';
import { InferGetStaticPropsType } from 'next';
import BlogPage from '../../../components/Blog/posts/BlogPage';
import { blogPageQuery } from '../../../components/Blog/posts/sanityQueries';
import StorefrontPageV2 from '../../../components/v2/StorefrontPage';
import { getStaticProps as getStaticStorefrontProps } from '../../../config/getProps';
import { fetchSanityDocumentWrapper } from '../../../lib/sanity/fetchSanityDocumentWrapper';

type PageProps = InferGetStaticPropsType<typeof getStaticProps>;

const BlogDetailPage = ({ config, initial, query }: PageProps) => {
  const { data } = useQuery(query, {}, { initial });
  return (
    <StorefrontPageV2 config={config} sanityDocument={data}>
      <BlogPage sanityDocument={data} />
    </StorefrontPageV2>
  );
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export async function getStaticProps(context: StaticPropsContext) {
  const { props, revalidate } = await getStaticStorefrontProps(context);

  const sanityProps = await fetchSanityDocumentWrapper<Sanity$BlogPage>({
    config: props.config,
    context,
    sanityQuery: ({ BU_CONFIG }) =>
      blogPageQuery(
        context.params.tag,
        context.params.slug,
        BU_CONFIG,
        context.locale,
      ),
    draftMode: context.draftMode,
  });

  return {
    props: {
      ...props,
      ...sanityProps,
    },
    revalidate,
    notFound: !sanityProps.initial.data,
  };
}

export default BlogDetailPage;
